import camelCase from 'lodash/camelCase';
import { userSegRedirectEntrypoint } from '@jira/redirect-entrypoints__user-seg-redirect/src/userSegRedirectEntrypoint.entrypoint.tsx';
import { MenuIdProjects } from '@jira/navigation-apps__constants/src/MenuIdProjects.tsx';
import { summarySoftwareEntrypoint } from '@jira/spa-apps__summary/src/summarySoftwareEntrypoint.entrypoint.tsx';
import { createPageEntryPoint } from '@jira/platform__routing-create-route-entry-point/src/index.tsx';
import { forgeProjectModuleResource } from '@jira/navigation-apps__resources/src/controllers/forge/index.tsx';
import { staticProjectSidebarConnectAddonsNavigationResource } from '@jira/navigation-apps__resources/src/controllers/sidebar/static-project-sidebar-connect-addons/index.tsx';
import { staticProjectSidebarNavigationResource } from '@jira/navigation-apps__resources/src/controllers/sidebar/static-project-sidebar/index.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { getNavigationResources } from '@jira/router-resources__navigation/src/getNavigationResources.tsx';
import { projectContextResource } from '@jira/router-resources__project-context/src/projectContextResource.tsx';
import { incidentExperimentTraitResource } from '@jira/router-resources__software-incidents/src/incidentExperimentTraitResource.tsx';
import { softwareSummaryRoute } from '@jira/router-routes__software-summary-routes/src/softwareSummaryRoute.tsx';
import { AsyncHorizontalNavJira } from '@jira/navigation-apps__horizontal-nav-jira/src/async.tsx';
import { softwareProjectLayout } from '@jira/platform__layouts-software-project-layout/src/index.tsx';
import { jiraHorizontalNavEntrypoint } from '@jira/navigation-apps__horizontal-nav-jira/src/jiraHorizontalNavEntrypoint.entrypoint.tsx';
import { projectThemeResource } from '@jira/router-resources__project-theme/src/projectThemeResource.tsx';
import type { Route } from '@atlassian/react-resource-router';

const summarySoftwarePageEntrypoint = createPageEntryPoint({
	main: summarySoftwareEntrypoint,
	horizontalNavigation: jiraHorizontalNavEntrypoint,
	redirect: userSegRedirectEntrypoint,
});

export const softwareSummaryRouteEntry: Route = createEntry(softwareSummaryRoute, () => ({
	group: 'software',
	ufoName: 'next-gen-summary',
	layout: softwareProjectLayout,

	navigation: {
		menuId: MenuIdProjects,
		horizontal: AsyncHorizontalNavJira,
	},

	resources: [
		...getNavigationResources(), // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them if needed
		// A guide to check & cleanup: https://hello.atlassian.net/wiki/x/Q8XybwE
		incidentExperimentTraitResource,
		// eslint-disable-next-line jira/router/no-project-context-resource
		projectContextResource,
		forgeProjectModuleResource,
		staticProjectSidebarNavigationResource,
		staticProjectSidebarConnectAddonsNavigationResource,
		// end of resources expanded from getNavigationSidebarProjectResource
		projectThemeResource,
	],

	meta: {
		reporting: {
			id: 'software-summary',
			packageName: camelCase('software-summary'),
			teamName: 'jira-werewolves',
		},
	},

	entryPoint: () => summarySoftwarePageEntrypoint,
	supportsPreviewPanel: true,
	supportsProjectTheme: 'full',

	bifrost: {
		bifrostGroup: 'shell-only',
	},
}));
